import { requestType } from '~/config/enum.config';
var SERVICE = 'management-service';
var CONTROLLER = 'systemLogController';
export default {
    /**
     * 查询日志
     */
    getAllSystemLogs: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllSystemLogs',
        type: requestType.Get
    }
};
